import { isAuthorableFieldType } from './is-authorable-field-type.js';
import { TEMPLATE_FIELD_CONFIG_SCHEMAS, } from './template-field-config.js';
/** Lenient read of a stored config: a malformed or unauthorable one degrades to `{}`. */
export function parseTemplateFieldConfig(typeId, config) {
    if (!isAuthorableFieldType(typeId))
        return {};
    const parsed = TEMPLATE_FIELD_CONFIG_SCHEMAS[typeId].safeParse(config ?? {});
    return parsed.success ? parsed.data : {};
}
//# sourceMappingURL=parse-template-field-config.js.map